
  import { Component, Vue } from 'vue-property-decorator';
  import { IEmployeeListModel, EmployeeListModel } from './EmployeeListModels';
  import EmployeeCreate from './EmployeeCreate.vue';
  import EmployeeEdit from './EmployeeEdit.vue';
  import { Client, EmployeeModel, IEmployeeModel } from '@/services/api.service';
  import * as StringUtils from '@/utilities/string.utils';
  import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
  import { EventBus } from '@/event-bus';
  import { EmployeeDeletedMessage } from '@/services/eventbus.models';
  @Component({
    filters: {
      toJobItemType: toJobItemTypeFormatter
    },
    components: {
      EmployeeCreate,
      EmployeeEdit
    }
  })
  export default class EmployeeList extends Vue {
    private employees: EmployeeListModel[] = [];

    private employeeInEdit: EmployeeListModel | null = null;
    private employeeToDelete: EmployeeListModel | null = null;
    private employeeToDeleteName: string = '';
    protected mounted() {
      this.fetchEmployees();
    }

    private fetchEmployees() {
      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);

      const employees = clientService.getEmployees().then(data => {
        const sortedData = data.sort((n1, n2) => StringUtils.stringCompare(n1.firstName || '', n2.firstName || ''));
        sortedData.forEach((emp: EmployeeModel) => {
          this.employees.push(new EmployeeListModel(emp));
        });
      });
    }

    private onEmployeeAddRequested() {
      console.log('EVENT:Add Employee requested ');
      this.$modal.show('modal-employee-create');
    }

    private onEmployeeEditRequested(value: IEmployeeListModel) {
      console.log('EVENT:Edit employee requested for ' + value.gid);
      this.employeeInEdit = value;
      this.$modal.show('modal-employee-edit');
    }

    private onDeleteEmployeeRequested(value: IEmployeeListModel) {
      console.log('EVENT:Delete employee requested for ' + value.gid);
      this.employeeToDelete = value;
      this.employeeToDeleteName = value.firstName + ' ' + value.lastName;
      // @ts-ignore
      this.$refs.deleteemployeeprompt.show();
    }

    private onContinueDeleteEmployee() {
      console.log('EVENT:Confirmed delete employee');
      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      if (this.employeeToDelete) {
        // @ts-ignore
        this.$Progress.start();
        const employees = clientService
          .deleteEmployee(this.employeeToDelete.gid)
          .then(data => {
            // got the deleted employee, so remove from the list
            // and then pop a message
            // @ts-ignore
            this.$Progress.finish();
            // Remove the employee from the list
            const reducedEmployees = this.employees.filter(e => e.gid !== data.gid);
            console.log(reducedEmployees);
            this.employees = reducedEmployees;
            // @ts-ignore
            this.$awn.success('Employee ' + this.employeeToDeleteName + ' deleted successfully');
            this.$emit('employee-deleted', data);
            EventBus.$emit('employee-deleted', new EmployeeDeletedMessage(data));
          })
          .catch(reason => {
            // Pop the error message
            const errMsg = 'An error occurred when deleting the employee: <br/><br/>' + reason;
            // @ts-ignore
            this.$Progress.finish();
            // @ts-ignore
            this.$awn.alert(errMsg);
          });
      }
    }
    private onEmployeeCreated(employee: IEmployeeModel) {
      // make sure this job item is for this job
      const newEmp = new EmployeeListModel(employee);
      this.employees.push(newEmp);
    }

    private onEmployeeUpdated(employee: IEmployeeModel) {
      console.log('Received employee-updated event');
      const theEmployee = this.employees.find(item => item.gid === employee.gid);
      if (theEmployee !== undefined) {
        Object.assign(theEmployee, employee);
      }
    }
  }
